import { storableError } from '../../util/errors';
import { fetchSeoPerformerPage } from '../../util/seoDiscoveryFetch';

export const FETCH_PERFORMER_REQUEST = 'app/SeoDiscoveryPerformerPage/FETCH_REQUEST';
export const FETCH_PERFORMER_SUCCESS = 'app/SeoDiscoveryPerformerPage/FETCH_SUCCESS';
export const FETCH_PERFORMER_ERROR = 'app/SeoDiscoveryPerformerPage/FETCH_ERROR';

const initialState = {
  payload: null,
  fetchInProgress: false,
  fetchError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_PERFORMER_REQUEST:
      return { ...state, fetchInProgress: true, fetchError: null };
    case FETCH_PERFORMER_SUCCESS:
      return { ...state, fetchInProgress: false, payload };
    case FETCH_PERFORMER_ERROR:
      return { ...state, fetchInProgress: false, fetchError: payload };
    default:
      return state;
  }
}

const fetchRequest = () => ({ type: FETCH_PERFORMER_REQUEST });
const fetchSuccess = payload => ({ type: FETCH_PERFORMER_SUCCESS, payload });
const fetchError = e => ({ type: FETCH_PERFORMER_ERROR, payload: storableError(e) });

export const loadPerformerData = performerSlug => dispatch => {
  dispatch(fetchRequest());
  return fetchSeoPerformerPage(performerSlug)
    .then(data => dispatch(fetchSuccess(data)))
    .catch(e => {
      dispatch(fetchError(e));
      throw e;
    });
};

export const loadData = (params, search, config) => dispatch => {
  const slug = params?.performerSlug;
  if (!slug) {
    return Promise.resolve();
  }
  return dispatch(loadPerformerData(slug));
};
